import { render, staticRenderFns } from "./BackupPaymentStage.vue?vue&type=template&id=72d3d932"
import script from "./BackupPaymentStage.vue?vue&type=script&lang=js"
export * from "./BackupPaymentStage.vue?vue&type=script&lang=js"
import style0 from "./BackupPaymentStage.vue?vue&type=style&index=0&id=72d3d932&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports